<template>
  <pagefra>
    <div
      class="displayAnalysis"
      v-loading.lock="loading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <iframe title="" :src="src" @load="loaded()" />
      <!-- <div class="right-go-back-button">
        <el-button
          circle
          icon="el-icon-right"
          @click="$router.push('/index')"
        ></el-button>
      </div> -->
    </div>
  </pagefra>
</template>

<script>
import global from "@/mixins/global.js";
export default {
  name: "displayAnalysis",
  mixins: [global],
  data() {
    return {
      src: "",
      isFirst: true,
      loading: false,
    };
  },
  created() {
    this.loading = true;
    this.$http
      .get(this.$apiConfig.get_bi_signature_url)
      .then((response) => {
        this.isFirst = false;
        let result = response.data;
        if (result.code == 0) {
          const token = localStorage.getItem("token");
          const url = window.config.analysisUrl;
          let connect = "?";
          if (url.indexOf("?") > 0) {
            connect = "&";
          }
          this.src = `${url}${connect}token=${token}&signature=${result.data}`;
        } else {
          this.loading = false;
          this.message(result.code, result.msg);
        }
      })
      .catch((error) => {
        this.loading = false;
        this.errorMessage(5);
        this.$sentry.captureException(error);
      });
  },
  mounted() {},
  methods: {
    loaded() {
      if (!this.isFirst) {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-main {
  // margin-top: -10px;
  padding: 0px;
  & > div {
    overflow: hidden;
  }
}
.displayAnalysis {
  width: 100%;
  height: 100%;
  padding: 0px 25px 20px;
  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }

  .right-go-back-button {
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    width: vw(30);
    z-index: 999999;
    .el-button {
      width: vw(60);
      height: vw(60);
      padding: 0;
      margin: 0 auto;
      border: none;
      background: rgba(0, 0, 0, 0.9);
      display: none;
      color: #fff;
      position: fixed;
      top: 50%;
      transform: translateY(-50%);
      right: vw(40);
    }
    /deep/.el-icon-right:before {
      font-size: 3rem;
    }
    &:hover {
      width: vw(100);
      .el-button {
        display: block;
      }
    }
  }
}
</style>